import React from 'react';
import Alert from '../alert/Alert';

const DEFAULT_DISMISS = () => {};

export function buildStatus(message, options = {}) {
  const {
    alertVariant = 'secondary',
    header = '',
    buttonVariant = 'outline-secondary',
    onDismiss = DEFAULT_DISMISS,
    buttonText = 'Okay',
  } = options;
  return (
    <Alert
      body={message}
      alertVariant={alertVariant}
      buttonVariant={buttonVariant}
      header={header}
      onDismiss={onDismiss}
      buttonText={buttonText}
    />
  );
}

export function buildSuccessStatus(message, onDismiss = DEFAULT_DISMISS) {
  return buildStatus(message, {
    buttonVariant: 'outline-success',
    alertVariant: 'success',
    header: 'Success',
    onDismiss,
  });
}

export function buildFailureStatus(message, onDismiss = DEFAULT_DISMISS) {
  return buildStatus(message, {
    buttonVariant: 'outline-danger',
    alertVariant: 'danger',
    header: 'Failure',
    onDismiss,
  });
}
